import { featureFlipping, Locale } from '@headless-workspace/config';
import { Result } from '@headless-workspace/core-domain';
import { ServerErrorCode } from '@headless-workspace/data';
import { CommonDI, LoggerType } from '../../../DI';
import { EcomConfigKeys, getCachedEcomConfigs } from '../config';
import { checkMemoCountrySelectorFeatureFlag } from '../countrySpecificities';
import { FooterSlotsValue } from '../footer';
import { CategoryValue } from '../navigation';
import {
    getMemoCatalogCategories,
    getMemoPersistentBannerSlot,
    getMemoPopularSearches,
    getMemoFooterSlots,
} from '../preload';
import { PageManager } from './PageManager';

export type RootPageParams = Partial<{
    categories: CategoryValue[];
    footerSlots: FooterSlotsValue;
    configs: Partial<Record<EcomConfigKeys, Result<unknown>>>;
}>;

type RootPreloadParams = {
    locale: Locale;
};

export const RootPageManager: PageManager<RootPageParams, RootPreloadParams> = {
    canGeneratePage({ categories, footerSlots, configs }: RootPageParams): boolean {
        const hasRequiredConfigs = featureFlipping.isConfigsFailoverCheckDisabled
            ? true
            : !!configs && !Object.values(configs).every((config) => config.type === 'empty');

        return (
            !!categories?.length &&
            // footer compliance is commented as it is missing on some locale like pl-PL
            // !!footerSlots?.compliance?.length &&
            !!footerSlots?.links.length &&
            // footer reinsurance is commented as it is missing on some locale like tr-TR
            // !!footerSlots?.reinsurance.length &&
            !!footerSlots?.socialNetwork.length &&
            hasRequiredConfigs
        );
    },

    preloadPageData({ locale }: RootPreloadParams): void {
        Promise.allSettled([
            getCachedEcomConfigs(locale),
            getMemoCatalogCategories(locale),
            getMemoFooterSlots(locale),
            getMemoPersistentBannerSlot(locale),
            getMemoPopularSearches(locale),
            checkMemoCountrySelectorFeatureFlag(locale),
        ]).catch((error) => {
            CommonDI.get(LoggerType).error(ServerErrorCode.PagePreload, error);
        });
    },
};
